import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransferinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M15 13v4.75A2.25 2.25 0 0 1 12.75 20h-7.5a2.25 2.25 0 0 1-1.59-.658 2.25 2.25 0 0 1-.66-1.59V13.25a2.25 2.25 0 0 1 .658-1.59 2.25 2.25 0 0 1 1.59-.66H9m-3 6h2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 12,
			height: 9,
			x: 9,
			y: 4,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			rx: 2.25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 8.5,
			r: 1.5,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M20 17v4m2-2-2-2-2 2M4 7V3M2 5l2 2 2-2"
		})
	]
});
export default SvgTransferinline;
